/**
 * FAQ questions that other pages link to directly (/faq#<anchor>). Kept here
 * rather than in FaqPage so a link to one does not pull the FAQ page into
 * that page's bundle.
 */

// "Hvordan sorteres annonsene?": linked beside "Sorter etter" on the search
// page and from the footer.
export const SORTING_ANCHOR = 'sortering';
